import { StyledPillButton, colors } from "@quickpoint.me/shared";
import styled from "styled-components";
import LockupIcon from "../../../icons/QP_Assets-18.svg?react";

export const Banner = () => {
  return (
    <div className="banner">
      {/* the lockup carries the wordmark — logo text is exempt from 1.4.9 */}
      <LockupIcon role="img" aria-label="QuickPoint" focusable="false" />
    </div>
  );
};

export const StyledAuth = styled.div`
  z-index: 60;
  `;

export const StyledInfo = styled.div``;

export const StyledError = styled.div.attrs({
  "role": "alert",
})`
    color: ${colors.textSafe.red}; /* 7.5:1 on white (AAA) — the old #FF6961 was 2.3:1 on black */
    padding-inline-start: 1rem;
    padding-block-start: 1rem;
    min-height: 2rem;`;

/** Full-width pill for the stacked auth actions; icons ride inside. */
export const AuthPillButton = styled(StyledPillButton)`
    width: 100%;
    font-size: 1rem;
    gap: 0.5em;

    svg {
      height: 1.25em;
      width: auto;
      flex-shrink: 0;
    }
`;
